import { useApiData } from './useApiData'

export type ProductDomainRequest = {
  domainCode?: string
  countryCode?: string
  accountingCodes?: string[]
}

export type PorductDomainResponse = {
  accountingCode?: string
  countryCode?: string
  craConsentRequired: boolean
  description?: string
  documentFormat?: string
  domainCode?: string
  productCategoryCode?: string
  productCode?: string
  reportAvailability?: number
  sortOrder?: number
}

export function useProductDomain(ProductDomainRequest: ProductDomainRequest = {}, skip = false) {
  const { data: productsDomainData, loading } = useApiData<{ products: PorductDomainResponse[] }>(
    {
      url: '/api/domain/products',
      method: 'post',
      data: ProductDomainRequest
    },
    {
      skip: skip
    }
  )

  return {
    loading,
    productsDomainData: productsDomainData?.products
  }
}
